import React, { useState } from 'react';
import { bool, func, object } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import template from 'url-template';
import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';

import {
    pingBasAgent,
    rebootAgent,
    restartAgentApplication,
    setAgent
} from '../../actions/basAgentActions';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import classes from './BasAgentsTableRowMenu.module.css';

const ManageUrl = template.parse('/iothub/basagents/manage{?company,basAgent}');

const BasAgentsTableRowMenu = ({
    agent,
    companyInfo,
    currentUser,
    currentScopes,
    hidden,
    history,
    location,
    onAssignAgentModal,
    onDeleteModal,
    onHandleSiteLinking,
    onRenameAgentModal,
    onResetConfirmationModal,
    onStopInventoryScan,
    onUnAssignAgentModal,
    pingBasAgent,
    rebootAgent,
    restartAgentApplication,
    setAgent
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    function isAdminAccount() {
        const isCompanyAdmin = isAllowed(currentScopes, Permissions('adminFull'));
        const superAdmin = currentUser.isSuperUser || currentUser.email.toLowerCase().includes('@key2act.com');

        return isCompanyAdmin || superAdmin;
    }

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleManage() {
        const values = new URLSearchParams(location.search);
        setAgent(agent);
        history.push(ManageUrl.expand({
            basAgent: agent.id,
            company:  values.get('company')
        }));
    }

    function handleToggleAssignAgentModal() {
        onAssignAgentModal(agent);
        handleClose();
    }

    function handleToggleDeleteModal() {
        onDeleteModal(agent);
        handleClose();
    }

    function handleToggleUnAssignAgentModal() {
        onUnAssignAgentModal(agent);
        handleClose();
    }

    function handleReboot() {
        rebootAgent(agent.id);
        handleClose();
    }

    function handlePingAgent() {
        pingBasAgent(agent.id);
        handleClose();
    }

    function handleToggleRenameAgentModal() {
        onRenameAgentModal(agent);
        handleClose();
    }

    function handleRestart() {
        restartAgentApplication(agent.id);
        handleClose();
    }

    function handleStopInventoryScan () {
        onStopInventoryScan(agent);
        handleClose();
    }

    function handleSiteLinking () {
        onHandleSiteLinking(agent);
        handleClose();
    }

    let assignmentItem;
    if (agent.serialNumber) {
        assignmentItem = (
            <MenuItem onClick={handleToggleUnAssignAgentModal}>
                <img
                    alt=""
                    className={classes.contextIcon}
                    src="/assets/images/unassignIconColor.svg"
                />
                Unassign Agent
            </MenuItem>
        );
    } else {
        assignmentItem = (
            <MenuItem onClick={handleToggleAssignAgentModal}>
                <img
                    alt=""
                    className={classes.contextIcon}
                    src="/assets/images/assignIconColor.svg"
                />
                Assign Agent
            </MenuItem>
        );
    }
    const deployment = agent.deployment.toLowerCase();

    return (
        <React.Fragment>
            <Button
                aria-owns={open ? 'render-props-menu' : undefined}
                aria-haspopup="true"
                onClick={handleOpen}
                className={classes.contextMenuButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={classes.contextMenu}
            >
                <MenuItem onClick={handleManage}>
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/SettingsFlat.svg"
                    />
                    Manage Agent
                </MenuItem>
                {
                    !hidden &&
                    <div>
                        {assignmentItem}
                        <MenuItem onClick={handleToggleRenameAgentModal}>
                            <img
                                alt=""
                                className={classes.contextIcon}
                                src="/assets/images/basAgentIconColor.svg"
                            />
                            Rename Agent
                        </MenuItem>
                        {
                            deployment !== 'software' &&
                            <MenuItem onClick={handleReboot}>
                                <img
                                    alt=""
                                    className={classes.contextIcon}
                                    src="/assets/images/rebootIconColor.svg"
                                />
                                Reboot Agent
                            </MenuItem>
                        }
                        <MenuItem onClick={handleRestart}>
                            <img
                                alt=""
                                className={classes.contextIcon}
                                src="/assets/images/restartAppIcon.svg"
                            />
                            Restart Application
                        </MenuItem>
                        <MenuItem onClick={handlePingAgent}>
                            <img
                                alt=""
                                className={classes.contextIcon}
                                src="/assets/images/pingIconColor.svg"
                            />
                            Ping Agent
                        </MenuItem>
                        <MenuItem onClick={handleToggleDeleteModal}>
                            <img
                                alt=""
                                className={classes.contextIcon}
                                src="/assets/images/deleteIconColor.svg"
                            />
                            Delete Agent
                        </MenuItem>
                        {
                            isAdminAccount() ?
                                <MenuItem onClick={handleSiteLinking}>
                                    <img
                                        alt=""
                                        className={classes.contextIcon}
                                        src="/assets/images/agentsitelink.svg"
                                    />
                                    Link To Sites
                                </MenuItem>
                                : null
                        }
                        { agent.serialNumber && currentUser.isSuperUser ?
                            <MenuItem onClick={handleStopInventoryScan}>
                                <img
                                    alt=""
                                    className={classes.contextIcon}
                                    src="/assets/images/removeIconRed.svg"
                                />
                                Stop Inventory Scan
                            </MenuItem>
                            : null
                        }
                    </div>
                }
            </Menu>
        </React.Fragment>
    );
};

BasAgentsTableRowMenu.defaultProps = {
    hidden:                   false,
    onAssignAgentModal:       () => {},
    onDeleteModal:            () => {},
    onHandleSiteLinking:      () => {},
    onRenameAgentModal:       () => {},
    onResetConfirmationModal: () => {},
    onStopInventoryScan:      () => {},
    onUnAssignAgentModal:     () => {},
    pingBasAgent:             () => {},
    rebootAgent:              () => {},
    restartAgentApplication:  () => {},
    setAgent:                 () => {}
};

BasAgentsTableRowMenu.propTypes = {
    agent:                    object,
    companyInfo:              object,
    hidden:                   bool,
    history:                  object,
    location:                 object,
    onAssignAgentModal:       func,
    onDeleteModal:            func,
    onHandleSiteLinking:      func,
    onRenameAgentModal:       func,
    onResetConfirmationModal: func,
    onStopInventoryScan:      func,
    onUnAssignAgentModal:     func,
    pingBasAgent:             func,
    rebootAgent:              func,
    restartAgentApplication:  func,
    setAgent:                 func
};

const mapStateToProps = state => ({
    currentUser:   state.currentUser,
    currentScopes: state.core.currentScopes
});

const mapDispatchToProps = {
    pingBasAgent,
    rebootAgent,
    restartAgentApplication,
    setAgent
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(BasAgentsTableRowMenu)
);
